export function getAggregation(dataType: string): string {
  if (['integer', 'decimal'].includes(dataType)) return 'sum';
  else if (['text', 'boolean'].includes(dataType)) return 'count';
  else if (['date', 'timestamp'].includes(dataType)) return 'max';
  return '';
}
